import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import AdminLayout from '../../../Shared/AdminLayout';
import DataContainer from '../../../Shared/DataContainer';
import DropdownButton from '../../../Shared/DropdownButton';
import Pagination from '../../../Shared/Pagination';
import Icon from '../../../Shared/Icon';
import { can } from '../../../utils';
import * as moment from 'moment';

const Index = () => {
     const { auth, errors, data } = usePage().props;
     const [values, setValues] = useState({});

     return (
          <React.Fragment key="security-index">
               <Helmet>
                    <title>Orders</title>
               </Helmet>
               <div className="max-w-7xl mx-auto p-2">
                    <InertiaLink className="font-semibold text-md text-gray-700 hover:text-gray-800 leading-tight" href={route('home')}>Dashboard</InertiaLink> | <span className="text-md text-gray-700 leading-tight">Orders</span>
               </div>
               {!data && (<div className="rounded col-span-12 bg-blue-100 text-blue-600 border border-blue-500 px-4 py-4 text-center">No orders yet :(</div>)}
               {data && (<DataContainer>
                    <table className="table-fixed col-span-12 text-sm">
                         <thead className="bg-gray-200">
                              <tr>
                                   <th className="px-2 py-1">Receipt No.</th>
                                   <th className="px-2 py-1">Reference</th>
                                   <th className="px-2 py-1">Method</th>
                                   <th className="px-2 py-1">Date</th>
                                   <th className="px-2 py-1">Status</th>
                                   <th className="px-2 py-1"></th>
                              </tr>
                         </thead>
                         <tbody>
                              {data.orders.data.map(({id, number, reference, method, status, filter, color, notify, date, end, view_only, can_prepare, can_facture, log}) => {
                                   return <tr key={id}>
                                        <td className="border px-2 py-1 text-center">
                                             {number} <br />
                                             {notify && (<span className="w-full ml-4 text-xs text-red-500">{`Appelez le client pour récupérer`}</span>)}
                                        </td>
                                        <td className="border px-2 py-1 text-center">{reference}</td>
                                        <td className="border px-2 py-1 text-center">{method}</td>
                                        <td className="border px-2 py-1 text-center">
                                             {moment(date).format('DD MMM YYYY @ hh:mm A')} <br />
                                        {log && (<span className="w-full ml-4 text-xs text-blue-500">{`${log.action} by ${log.user} ${moment(end).to(moment(date))}`}</span>)}
                                             {!log && (<span className="w-full ml-4 text-xs text-blue-500">{`${moment(end).to(moment(date))}`}</span>)}
                                        </td>
                                        <td className="border px-2 py-1 text-center font-semibold" style={{color: `#${color}`}}>{status}</td>
                                        <td className="border px-2 py-1 text-center">
                                             <DropdownButton caption="Actions" color="blue">
                                                  {can(auth.user, 'read-order') && (<InertiaLink href={route('purchase.show', id)} className="flex block px-6 py-2 text-gray-600 hover:bg-gray-100 hover:text-gray-700">
                                                       <Icon name={'eye'} className={'fill-current w-5 h-5 mr-2'} /> View Details
                                                  </InertiaLink>)}
                                                  {(can(auth.user, 'facture-order') && can_facture) && (<InertiaLink href={route('purchase.get.facture', id)} className="flex block px-6 py-2 text-gray-600 hover:bg-gray-100 hover:text-gray-700">
                                                       <Icon name={'money'} className={'fill-current w-5 h-5 mr-2'} /> Add ACCPAC No.
                                                  </InertiaLink>)}
                                                  {(can_prepare && can(auth.user, 'prepare-order')) && (<InertiaLink href={route('purchase.prepare', id)} className={`flex block px-6 py-2 text-gray-${(filter != 3)?'600':'300 line-through'} hover:bg-gray-100 hover:text-gray-700`}>
                                                       <Icon name={'prepare'} className={'fill-current w-5 h-5 mr-2'} /> Prepare
                                                  </InertiaLink>)}
                                             </DropdownButton>
                                        </td>
                                   </tr>
                              })}
                         </tbody>
                    </table>
               </DataContainer>)}
          </React.Fragment>
     );
};

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Index.layout = page => <AdminLayout children={page} header={'Orders'} />;

export default Index;
